import s from "./LoaderSpinner.module.css";

function LoaderSpinner() {
  return (
    <div className={s.spinner}>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
      <div className={s["spinner-blade"]}></div>
    </div>
  );
}

export default LoaderSpinner;
